"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "piobbico": {
    "cc4a77f8": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "skipSearch": false
    }],
    "baciardi": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "17edea40": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "skipSearch": false
    }],
    "cardella": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a280852e": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "skipSearch": false
    }],
    "castiglione": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3c937b17": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "skipSearch": false
    }],
    "cuppio": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0088d58b": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "skipSearch": false
    }],
    "finocchietto": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e851eaea": [{
      "hkey": "6eb8f322",
      "slug": "fratta",
      "name": "Fratta",
      "primary": true,
      "skipSearch": false
    }],
    "fratte": [{
      "hkey": "6eb8f322",
      "slug": "fratta",
      "name": "Fratta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a70b7a7f": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "skipSearch": false
    }],
    "le-ville": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa7d085e": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "skipSearch": false
    }],
    "monteforno": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a292b875": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "skipSearch": false
    }],
    "rocca-leonella": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2b0bcd27": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "skipSearch": false
    }],
    "san-silvestro": [{
      "hkey": "b6cd3755",
      "slug": "piobbico",
      "name": "Piobbico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;